import type { ChainConfig } from "./types";

interface WalletConnectProvider extends EthereumProvider {
  enable(): Promise<string[]>;
}

export function walletConnectConfigured(): boolean {
  return walletConnectProjectId() !== null;
}

export async function connectWalletConnect(config: ChainConfig): Promise<{
  provider: EthereumProvider;
  account: string;
}> {
  const projectId = walletConnectProjectId();
  if (projectId === null) {
    throw new Error("WalletConnect project ID is not configured");
  }
  if (config.chain.type !== "evm") {
    throw new Error("WalletConnect is not configured for this chain");
  }

  const { EthereumProvider: WalletConnectEthereumProvider } =
    await import("@walletconnect/ethereum-provider");
  const provider = (await WalletConnectEthereumProvider.init({
    projectId,
    metadata: {
      name: "zkFold Smart Wallet",
      description: "Send and claim zkFold Smart Wallet payments",
      url: window.location.origin,
      icons: [new URL("/icon.png", window.location.origin).toString()],
    },
    showQrModal: true,
    optionalChains: [config.chain.chainId],
  })) as WalletConnectProvider;

  const accounts = await provider.enable();
  const account = accounts[0];
  if (account === undefined) {
    throw new Error("No wallet account selected");
  }

  return { provider, account };
}

function walletConnectProjectId(): string | null {
  const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID?.trim();
  return projectId === undefined || projectId.length === 0 ? null : projectId;
}
